import format from 'date-fns/format';
import React, { memo, ReactElement } from 'react';
import { IProduct } from 'reactApp/modules/products/products.types';
import { defaultDateFormat } from 'reactApp/utils/formatDate';
import { getPeriodName, getTrialOrDiscountDateEnd } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';

import styles from './TrialPromoSidebar.css';

export const TrialPromoSidebar = memo(({ product }: { product: IProduct }): ReactElement => {
    const { space, trialPeriod, discountPeriod, period, discountPrice, price, hasTrial } = product ?? {};
    const freePeriod = hasTrial ? trialPeriod : discountPeriod;
    const priceText = hasTrial ? 'бесплатно' : `за ${formatPrice(discountPrice)} ₽`;

    return (
        <div className={styles.root}>
            <div className={styles.tariffInfo}>
                <div className={styles.header}>
                    Получите <span>{space?.value}</span> <br />
                    {priceText} на {getPeriodName(freePeriod || period)}
                </div>
                <div className={styles.text}>За один рубль вы получите:</div>
                <ol className={styles.features}>
                    <li>{space?.value} дополнительного места</li>
                    <li>Без рекламы в Почте и Облаке</li>
                    <li>Загрузку файлов до 100 ГБ</li>
                    <li>Автоудаление папок</li>
                    <li>Приоритетную поддержку</li>
                </ol>
            </div>
            <div className={styles.paymentInfo}>
                Стоимость тарифа {formatPrice(price)}&nbsp;₽, начиная с&nbsp;
                {Boolean(freePeriod) && format(getTrialOrDiscountDateEnd(freePeriod), defaultDateFormat)}. Подписка продлевается автоматически, её
                можно отменить в любой момент.
            </div>
        </div>
    );
});

TrialPromoSidebar.displayName = 'TrialPromoSidebar';
